<div class="modal-header">
  <h5 class="modal-title">{{remark}} — Calculation Detail</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="d-flex flex-wrap gap-4 mb-3 small align-items-center">
    <div><span class="text-muted">Amount:</span> <strong>{{amount | number:'1.3-3'}}</strong></div>
    <div *ngIf="balance != null"><span class="text-muted">Balance:</span> <strong>{{parseFloat(balance) | number:'1.3-3'}}</strong></div>
    <div *ngIf="date"><span class="text-muted">Date:</span> <strong>{{date | date:'dd-MM-y'}}</strong></div>
    <div *ngIf="verified === true">
      <span class="badge bg-success-subtle text-success border border-success-subtle"
            title="The breakdown below sums exactly to the amount paid.">✓ Verified — breakdown equals paid amount</span>
    </div>
    <div *ngIf="verified === false">
      <span class="badge bg-danger-subtle text-danger border border-danger-subtle"
            title="The breakdown does not match the amount paid — investigate.">⚠ Mismatch — breakdown {{ breakdownTotal | number:'1.3-3' }} vs paid {{ amount | number:'1.3-3' }}</span>
    </div>
  </div>

  <table *ngIf="parsed" class="table table-sm table-bordered mb-0">
    <thead class="table-light">
      <tr>
        <th>Customer</th>
        <th>Level</th>
        <th>Game</th>
        <th class="text-end">Lose Value</th>
        <th class="text-end">Game Rate</th>
        <th class="text-end">Rolling</th>
        <th class="text-end">Rate</th>
        <th class="text-end">Player Share</th>
        <th class="text-end">Commission</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let l of lines">
        <td class="text-nowrap">{{l.source}}</td>
        <td>{{l.level}}</td>
        <td>{{l.game}}</td>
        <td class="text-end">{{l.profit | number:'1.2-2'}}</td>
        <td class="text-end"><ng-container *ngIf="l.gameRatePct != null; else noGameRate">{{l.gameRatePct | number:'1.0-2'}}%</ng-container><ng-template #noGameRate>—</ng-template></td>
        <td class="text-end"><ng-container *ngIf="l.gameRatePct != null; else noRolling">{{l.rollingPct | number:'1.0-2'}}%</ng-container><ng-template #noRolling>—</ng-template></td>
        <td class="text-end">{{l.ratePct | number:'1.0-2'}}%</td>
        <td class="text-end">{{l.poolPct | number:'1.0-2'}}%</td>
        <td class="text-end">{{l.value | number:'1.3-3'}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr class="fw-bold table-light">
        <td colspan="8" class="text-end">Total</td>
        <td class="text-end">{{amount | number:'1.3-3'}}</td>
      </tr>
    </tfoot>
  </table>
  <div *ngIf="parsed" class="text-muted small mt-2">
    Commission = Lose Value &times; Game Rate &times; 1% &times; Rate &times; Player Share
    <span class="text-muted">(Game Rate is set in the automated rule, per game with general rate as fallback — today 50% — and applies to every level; Rate is the level rolling rate: L1 100% / L2 30% / L3 20%; each lose value pays every covered level)</span>
  </div>

  <div *ngIf="!parsed">
    <div class="text-muted small mb-1">Calculation</div>
    <pre class="border rounded p-2 bg-light mb-0"
         style="white-space:pre-wrap; word-break:break-word;">{{row?.calculation_detail || rawFormula || '-'}}</pre>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.close()">Close</button>
</div>
